import * as yup from "yup";
import MiturLogo from '../../../assets/images/MiturLogo.png'
export const MiturLogoImage = MiturLogo;
export const AuthBackgroundImage = '/robin-canfield-cib574f9CFw-unsplash.jpg';

export const FormSchema = yup.object({
    id: yup.string().required('Este campo es requerido'),
    password: yup.string().required('Este campo es requerido'),
  }).required();